import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';

import './nikke-element.scss';

interface IProps {
  type: string;
}

export const NikkeFaction: React.FC<IProps> = ({ type }) => {
  return (
    <div className={`nikke-manu type-${type}`}>
      {type === 'Elysion' && (
        <>
          {' '}
          <StaticImage
            src="../../../../images/nikke/icons/man_elysion.png"
            alt="Elysion"
          />
        </>
      )}
      {type === 'Tetra' && (
        <>
          {' '}
          <StaticImage
            src="../../../../images/nikke/icons/man_tetra.png"
            alt="Tetra"
          />
        </>
      )}
      {type === 'Missilis' && (
        <>
          {' '}
          <StaticImage
            src="../../../../images/nikke/icons/man_missilis.png"
            alt="Missilis"
          />
        </>
      )}
      {type === 'Pilgrim' && (
        <>
          {' '}
          <StaticImage
            src="../../../../images/nikke/icons/man_pilgrim.png"
            alt="Pilgrim"
          />
        </>
      )}
      {type === 'Abnormal' && (
        <>
          {' '}
          <StaticImage
            src="../../../../images/nikke/icons/man_abnormal.png"
            alt="Abnormal"
          />
        </>
      )}
    </div>
  );
};
